var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0722 5.21337C18.436 5.49479 17.7614 5.67962 17.0706 5.76176C17.7984 5.3261 18.3429 4.64075 18.6029 3.83337C17.919 4.23967 17.1705 4.52564 16.3899 4.67884C15.731 3.97588 14.8101 3.57752 13.8466 3.57862C11.9223 3.57862 10.3615 5.13884 10.3615 7.06402C10.3615 7.33715 10.3929 7.60202 10.4514 7.85757C7.55383 7.7117 4.98683 6.32504 3.26742 4.21617C2.95785 4.74806 2.79515 5.35265 2.79597 5.96806C2.79597 7.17716 3.41144 8.24437 4.34635 8.86917C3.79291 8.85167 3.25167 8.7022 2.76776 8.43311C2.76722 8.44775 2.76722 8.46239 2.76722 8.47623C2.76722 10.1653 3.9686 11.5743 5.56343 11.8942C5.26411 11.9752 4.95537 12.0162 4.64529 12.0159C4.42008 12.0159 4.20153 11.9952 3.9891 11.9544C4.43286 13.3387 5.71916 14.3466 7.24477 14.3742C6.01021 15.3432 4.48568 15.8688 2.9163 15.8666C2.63854 15.8668 2.36101 15.8504 2.08521 15.8176C3.67847 16.8418 5.53304 17.3854 7.42712 17.3834C13.8381 17.3834 17.3434 12.0729 17.3434 7.46759C17.3434 7.31692 17.3398 7.16572 17.3331 7.01664C18.0154 6.52371 18.6043 5.91306 19.0722 5.21337Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.63669b00258b0e0cb1c464c8bed3778d.svg";
export { ForwardRef as ReactComponent };